'use client';
import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ConfirmModalProps {
  open: boolean;
  title: string;
  description: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'danger' | 'warning' | 'default';
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmModal({
  open,
  title,
  description,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'danger',
  onConfirm,
  onCancel,
}: ConfirmModalProps) {
  if (!open) return null;

  const confirmColor = variant === 'danger' ?'bg-negative hover:bg-negative/90 text-white'
    : variant === 'warning' ?'bg-warning hover:bg-warning/90 text-black' :'bg-primary hover:bg-primary/90 text-white';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 animate-fade-in">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onCancel} />
      <div className="relative bg-card border border-border rounded-xl p-6 w-full max-w-md shadow-2xl animate-slide-up">
        <div className="flex items-start gap-4">
          <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${
            variant === 'danger' ? 'bg-negative/15' : variant === 'warning' ? 'bg-warning/15' : 'bg-primary/15'
          }`}>
            <Icon
              name={variant === 'danger' ? 'ExclamationTriangleIcon' : 'InformationCircleIcon'}
              size={20}
              className={variant === 'danger' ? 'text-negative' : variant === 'warning' ? 'text-warning' : 'text-primary'}
            />
          </div>
          <div className="flex-1">
            <h3 className="text-base font-700 text-foreground mb-1">{title}</h3>
            <p className="text-sm text-muted-foreground">{description}</p>
          </div>
        </div>
        <div className="flex items-center justify-end gap-3 mt-6">
          <button
            onClick={onCancel}
            className="px-4 py-2 rounded-lg text-sm font-500 text-muted-foreground hover:bg-muted hover:text-foreground transition-all"
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            className={`px-4 py-2 rounded-lg text-sm font-600 transition-all active:scale-95 ${confirmColor}`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}